// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const NoCodeCta: MarkdocTagRegistration = {
  tag: 'no-code-cta',
  component: 'NoCodeCta',
};
